import React, { Component } from 'react';
import { Button, Grid, MenuList, Tooltip } from '@material-ui/core';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import * as HelperFunctions from '../components/helpers';

const styles = theme => ({
    layoutRoot: {},
    button: {
        margin: theme.spacing.unit,
        minWidth: '80%',
        maxWidth: '80%',
        whiteSpace: 'nowrap',
        // width: '200px'
    },
});

class TabPanelButtons extends Component {
    shouldDisplayButton = (button_info) => {
        const { component_name, view_type } = this.props;
        const button_type = button_info.type;
        let should_display_button = true;

        // Sets button visability based on view_type
        if (button_info.hidden 
            || (view_type === 'detail' && (button_type === 'update' || button_type === 'create' || button_type === 'delete' || button_type === 'activate' || button_type === 'deactivate'))
            || (view_type === 'create' && (button_type === 'delete' || button_type === 'activate' || button_type === 'deactivate'))
        ) {
            should_display_button = false;
        }

        // Sets button visability bsed on permissions
        if (button_type !== 'back') {
            should_display_button = (should_display_button && (HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, component_name, button_type) || button_info.overridePermission));
        }

        return should_display_button;
    }

    getButtonGridSize = (button_list_length) => {
        if (button_list_length === 5) {
            return 2;
        }

        return 12 / button_list_length;
    }

    // Adds defaults for missing settings
    standardizeButton = (button_info) => {
        let new_button_info = button_info;

        if (typeof new_button_info.display === 'undefined') {
            new_button_info.display = new_button_info.type;
        }

        if (typeof new_button_info.onClick === 'undefined') {
            new_button_info.onClick = () => { };
        }

        if (typeof new_button_info.disabled === 'undefined') {
            new_button_info.disabled = false;
        }

        if (typeof new_button_info.color === 'undefined') {
            new_button_info.color = 'default';
        }

        if (typeof new_button_info.button_size === 'undefined') {
            new_button_info.button_size = 'medium';
        }

        if (typeof new_button_info.largeLabel === 'undefined') {
            new_button_info.largeLabel = false;
        }

        return new_button_info;
    }

    generateToolTipContent = (tooltip_info, button_content) => {
        return (
            <Tooltip
                title={<React.Fragment><div>{tooltip_info.content}</div></React.Fragment>}
            >
                {button_content}
            </Tooltip>
        )
    }

    generateButtonContent = (button_info, button_grid_size) => {
        const standardized_button_info = this.standardizeButton(button_info);
        return (
            <Grid item xs={button_grid_size}>
                <Button 
                    className = {this.props.classes.button}
                    variant   = "contained" 
                    onClick   = {standardized_button_info.onClick}
                    disabled  = {standardized_button_info.disabled}
                    color     = {standardized_button_info.color}
                    size      = {standardized_button_info.button_size}
                    style     = {standardized_button_info.largeLabel ? {width: '300px'} : {}}
                >
                    {standardized_button_info.display}
                </Button>
            </Grid>
        )
    }
    
    generateButton = (button_info, button_grid_size, index) => {
        let button_content = this.generateButtonContent(button_info, button_grid_size);

        if (typeof button_info.tooltip !== 'undefined' && button_info.tooltip.active && button_info.tooltip.content) {
            button_content = this.generateToolTipContent(button_info.tooltip, button_content);
        }

        return (<React.Fragment key={index}>{button_content}</React.Fragment>)
    }

	render() {
        const { button_list } = this.props;
        const filtered_button_list = (button_list || []).filter((button_info) => this.shouldDisplayButton(button_info));
        const button_grid_size     = this.getButtonGridSize(filtered_button_list.length);
        const button_display       = filtered_button_list.map((button_info, index) => this.generateButton(button_info, button_grid_size, index));
        
        return (
            <div
                className='flex items-center'
                style={{
                    margin: '-1.5px 4px 0 4px'
                }}>
                <Grid container
                    spacing={0}
                >
                    {button_display}
                </Grid>
            </div>
        )
	};
}

function mapStateToProps({ auth, quickPanel }) {
	return {
		auth:           auth,
		quickPanelOpen: quickPanel.state
	}
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, null)(TabPanelButtons)));



// WEBPACK FOOTER //
// src/main/components/TabPanelButtons.js